import { motion } from "framer-motion";
import { Instagram, Youtube, Linkedin, Mail } from "lucide-react";
import XLogo from "./XLogo";
import { DEFAULT_SOCIALS } from "../../lib/followers";
import { openTrackedLink, trackClick, resolveImg } from "../../lib/api";

const ICONS = {
  instagram: Instagram,
  youtube: Youtube,
  linkedin: Linkedin,
  x: XLogo,
  twitter: XLogo,
};
const PLATFORM_LABEL = {
  instagram: "Instagram",
  youtube: "YouTube",
  linkedin: "LinkedIn",
  x: "X",
  twitter: "X",
};

export default function SocialLinks({ settings }) {
  const list = (settings.social_links && settings.social_links.length ? settings.social_links : DEFAULT_SOCIALS)
    .slice()
    .sort((a, b) => (a.order || 0) - (b.order || 0));

  return (
    <motion.section
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.55, duration: 0.55 }}
      className="mt-3"
    >
      <div className="mx-auto flex max-w-[320px] flex-col items-center gap-1.5">
        {list.map((s, i) => {
          const Icon = ICONS[s.platform] || Instagram;
          return (
            <button
              key={i}
              onClick={() =>
                openTrackedLink(s.url, {
                  item_type: "social",
                  item_name: `${PLATFORM_LABEL[s.platform] || s.platform} · ${s.label}`,
                })
              }
              data-testid={`social-row-${i}`}
              className="flex items-center justify-center gap-1.5 text-[11px] font-medium text-white/65 transition-colors hover:text-white"
            >
              <Icon size={12} className="text-white/80" />
              {s.image ? (
                <img src={resolveImg(s.image)} alt={s.label} className="h-4 w-4 rounded-full object-cover ring-1 ring-white/20" />
              ) : null}
              <span className="uppercase tracking-wide text-white/40">{PLATFORM_LABEL[s.platform] || s.platform}</span>
              <span className="text-white/85">{s.label}</span>
              <span className="text-white/40">· {s.followers}</span>
            </button>
          );
        })}

        <a
          href={`mailto:${settings.email}`}
          onClick={() => trackClick({ item_type: "contact", item_name: "Contact Me" })}
          data-testid="contact-me-button"
          className="mt-0.5 flex items-center justify-center gap-1.5 text-[11px] font-medium text-white/65 transition-colors hover:text-white"
        >
          <Mail size={12} className="text-white/80" />
          <span className="uppercase tracking-wide text-white/40">Contact</span>
          <span className="text-white/85">{settings.email}</span>
        </a>
      </div>
    </motion.section>
  );
}
